import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Divider, Paper, Typography } from '@mui/material'
import { PieChart } from '@mui/x-charts/PieChart'

import { useGetCaseStatisticsQuery } from '../../../features/cases/caseSlice'
import { useTranslation } from 'react-i18next'
import CustomNoRowsOverlay from '../../../components/common/datagrid/CustomNoRowsOverlay'

const CasesByCategory = () => {
  const { t } = useTranslation(['messages', 'common'])

  const { period } = useSelector((state) => state.statistics)
  const { data: statisticsResponse, isLoading, isFetching } = useGetCaseStatisticsQuery({ type: 'by_category', period })
  const { data: statisticsRaw } = statisticsResponse || { data: [] }

  const statistics = useMemo(() => {
    const withoutCategory = statisticsRaw.filter(({ _id }) => _id === null || !_id)
    const totalWithoutCategory = withoutCategory.reduce((acc, item) => acc + item.total, 0)

    const statistics = statisticsRaw.filter(({ _id }) => Boolean(_id))

    if (totalWithoutCategory > 0) {
      return [
        ...statistics,
        { _id: t('messages:statistics.alerts.categories.NOT_DEFINED'), total: totalWithoutCategory },
      ]
    }
  }, [t, statisticsRaw])

  const total = statistics?.reduce((acc, item) => acc + item.total, 0)

  const data = useMemo(
    () =>
      statistics?.map((stat) => ({
        id: stat._id || 'NO',
        value: stat.total,
        label: `${stat._id} (${stat.total})`,
        percentage: Number.parseFloat((stat.total * 100) / total).toFixed(2),
      })),
    [statistics, total],
  )

  return (
    <Paper elevation={0} className="home-category-wrapper">
      <Typography variant="text4">{t('messages:statistics.cases.title.by_category')}</Typography>
      <Divider sx={{ marginTop: '1rem' }} />
      {data ? (
        <PieChart
          slotProps={{
            legend: {
              direction: 'column',
            },
          }}
          series={[
            {
              data: data || [],
              highlightScope: { fade: 'global', highlight: 'item' },
              faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
              valueFormatter: (item) => `${item.percentage}%`,
            },
          ]}
          loading={isFetching || isLoading}
          height={350}
        />
      ) : (
        <CustomNoRowsOverlay />
      )}
    </Paper>
  )
}

export default CasesByCategory
